<div class="p-2">
  <div class="font-semibold text-2xl mb-3" data-clarity-unmask="true">Prywatność</div>

  <div class="main-card p-3">
    <div class="font-semibold text-xl mb-2" data-clarity-unmask="true">Analityka korzystania z panelu</div>
    <p class="text-sm text-gray-600 mb-3">
      Panel korzysta z Microsoft Clarity, które rejestruje sposób korzystania z interfejsu (nagrania sesji, mapy
      kliknięć), aby ułatwić nam jego ulepszanie. Treść wyświetlanych danych, w tym dane kursantów, jest w
      nagraniach maskowana. Twoja decyzja dotyczy analitycznych plików cookie i jest zapamiętywana w tej
      przeglądarce.
    </p>
    @if (!enabled) {
      <p class="text-sm text-gray-500 mb-3">W tym środowisku analityka jest wyłączona.</p>
    }

    <div class="form-decorator top-decorator flex align-items-center">
      <label class="title" for="analytics-consent">Zgoda na analityczne pliki cookie</label>
      <div class="form-wraper flex align-items-center gap-3">
        <p-inputSwitch
          inputId="analytics-consent"
          [ngModel]="consent === 'granted'"
          (ngModelChange)="toggle($event)"
        ></p-inputSwitch>
        <span class="text-sm text-gray-600">{{ statusLabel }}</span>
      </div>
    </div>

    @if (privacyPolicyUrl) {
      <p class="text-sm mt-3">
        <a [href]="privacyPolicyUrl" target="_blank" rel="noopener">Polityka prywatności</a>
      </p>
    }
  </div>
</div>
